import styles from '../styles/Footer.module.css'

export default function Footer() {
  return (
    <>
      <div className={styles.footer}>
        Copyright © 2024 Book Nook. All Right Reserved.
      </div>
    </>
  )
}
